import { render, staticRenderFns } from "./DropdownSelector.vue?vue&type=template&id=6b1788f8&"
import script from "./DropdownSelector.vue?vue&type=script&lang=js&"
export * from "./DropdownSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports